import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import data from './herramienta_accesorio.json'

export class herramienta_accesorio extends React.Component {

	componentDidMount () {
        const script = document.createElement("script");

        script.async = true;
        
		script.innerHTML = " $('.linkTable').click(function(event) {$('html').animate({ scrollTop: 0 }, 'slow');});"; 





        document.body.appendChild(script);


    }


	render(){

		return (
				<div id="inicio">
					
					<section class="container-fluid section-nuestros-productos">
					<article class="row">
									<div class="col-md-12 card-col-flex">


							<table class="table card-lb">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Accesorios</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="row">1</th>
										<td>ALICATES</td>
									</tr>
									<tr>
										<th scope="row">2</th>
										<td>ARCOS PARA SIERRA</td>
									</tr>
									<tr>
										<th scope="row">3</th>
										<td>CAJAS DE HERRAMIENTAS</td>
									</tr>
									<tr>
										<th scope="row">4</th>
										<td>CALIBRES PLASTICOS Y METALICOS</td>
									</tr>
									<tr>
										<th scope="row">5</th>
										<td>CANDADOS</td>
									</tr>
									<tr>
										<th scope="row">6</th>
										<td>CEPILLOS ALAMBRE</td>
									</tr>
									<tr>
										<th scope="row">7</th>
										<td>CINTAS ADHESIVAS</td>
									</tr>
									<tr>
										<th scope="row">8</th>
										<td>CINTAS AISLADORAS</td>
									</tr>
									<tr>
										<th scope="row">9</th>
										<td>CINTAS METRICAS</td>
									</tr>
									<tr>
										<th scope="row">10</th>
										<td>CORTA CAÑO PVC, COBRE Y ALUMINIO</td>
									</tr>
									<tr>
										<th scope="row">11</th>
										<td>CORTAFIERRO Y PUNTA</td>
									</tr>
									<tr>
										<th scope="row">12</th>
										<td>CORTAPERNOS</td>
									</tr>
									<tr>
										<th scope="row">13</th>
										<td>CUTTERS</td>
									</tr>
									<tr>
										<th scope="row">14</th>
										<td>DESTORNILLADORES</td>
									</tr>
									<tr>
										<th scope="row">15</th>
										<td>DOBLADORA DE CAÑO</td>
									</tr>
									<tr>
										<th scope="row">16</th>
										<td>ESCUADRAS</td>
									</tr>
									<tr>
										<th scope="row">17</th>
										<td>ESPATULAS</td>
									</tr>

									<tr>
										<th scope="row">18</th>
										<td>ESTUCHES CON DIVISIONES</td>
									</tr>
									<tr>
										<th scope="row">19</th>
										<td>LLAVES</td>
									</tr>
									<tr>
										<th scope="row">20</th>
										<td>LLAVES AJUSTABLES</td>
									</tr>
									<tr>
										<th scope="row">21</th>
										<td>LLAVES PARA CAÑOS</td>
									</tr>
									<tr>
										<th scope="row">22</th>
										<td>MALACATES A CABLE Y CINTA</td>
									</tr>
									<tr>
										<th scope="row">23</th>
										<td>MANDRILES</td>
									</tr>
									<tr>
										<th scope="row">24</th>
										<td>MANGUERAS ESPIRALADAS</td>
									</tr>

									<tr>
										<th scope="row">25</th>
										<td>MAQUINAS ELECTRICAS ARGENTEC</td>
									</tr>
									<tr>
										<th scope="row">26</th>
										<td>MARTILLOS</td>
									</tr>
									<tr>
										<th scope="row">27</th>
										<td>MAZAS</td>
									</tr>
									<tr>
										<th scope="row">28</th>
										<td>METRO MADERA</td>
									</tr>
									<tr>
										<th scope="row">29</th>
										<td>MICROMETROS</td>
									</tr>

									<tr>
										<th scope="row">30</th>
										<td>MORSAS</td>
									</tr>
									<tr>
										<th scope="row">31</th>
										<td>NIVELES</td>
									</tr>
									<tr>
										<th scope="row">32</th>
										<td>NUMEROS Y LETRAS CALADAS</td>
									</tr>
									<tr>
										<th scope="row">33</th>
										<td>NUMEROS Y LETRAS DE GOLPE</td>
									</tr>
									<tr>
										<th scope="row">34</th>
										<td>PAPEL ESPAÑA</td>
									</tr>
									<tr>
										<th scope="row">35</th>
										<td>PESTAÑADORAS PARA CAÑOS</td>
									</tr>
									<tr>
										<th scope="row">36</th>
										<td>PINCELES</td>
									</tr>
									<tr>
										<th scope="row">37</th>
										<td>PINTURA EN AEROSOL</td>
									</tr>

									<tr>
										<th scope="row">38</th>
										<td>PINZAS</td>
									</tr>
									<tr>
										<th scope="row">39</th>
										<td>PISTOLAS APLICADORAS</td>
									</tr>
									<tr>
										<th scope="row">40</th>
										<td>PISTOLAS ENCOLADORAS</td>
									</tr>
									<tr>
										<th scope="row">41</th>
										<td>PISTOLAS PARA PINTURA</td>
									</tr>
									<tr>
										<th scope="row">42</th>
										<td>PRENSA</td>
									</tr>

									<tr>
										<th scope="row">43</th>
										<td>PUNTOS DE MARCAR</td>
									</tr>
									<tr>
										<th scope="row">44</th>
										<td>PUNTOS DE TRAZAR</td>
									</tr>
									<tr>
										<th scope="row">45</th>
										<td>REGLAS</td>
									</tr>
									<tr>
										<th scope="row">46</th>
										<td>REMACHADORA POP Y PARA TUERCA REMACHE</td>
									</tr>
									<tr>
										<th scope="row">47</th>
										<td>RESORTES</td>
									</tr>
									<tr>
										<th scope="row">48</th>
										<td>SACA ESPIGA</td>
									</tr>
									<tr>
										<th scope="row">49</th>
										<td>SACABOCADOS A GOLPE</td>
									</tr>
									<tr>
										<th scope="row">50</th>
										<td>SARGENTOS</td>
									</tr>

									<tr>
										<th scope="row">51</th>
										<td>SERRUCHOS</td>
									</tr>
									<tr>
										<th scope="row">52</th>
										<td>SOPLETES ZINGUEROS</td>
									</tr>
									<tr>
										<th scope="row">53</th>
										<td>TENAZAS</td>
									</tr>
									<tr>
										<th scope="row">54</th>
										<td>TESTERS PARA ELECTRICIDAD</td>
									</tr>
									<tr>
										<th scope="row">55</th>
										<td>TIJERAS</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>		
									<td colspan="2" className="text-center"><button className="topScroll linkTable">subir</button></td>
									</tr>
								</tfoot>
							</table>

						</div>
									   
								
					</article>
				</section>		


				</div>

				


				);
	}
} 


// WEBPACK FOOTER //
// ./src/components/herramienta_accesorio.js